var map = {
	"./app.js": "3905",
	"./cache.js": "82ef",
	"./code.js": "1178",
	"./menus.js": "db8c",
	"./router.js": "3db0",
	"./settings.js": "5384",
	"./site.js": "d9b8",
	"./user.js": "df76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c01e";